import {apiService} from '@/core/api';
import {API_ENDPOINTS} from '@/core/constants/endpoints';
import {
  UpdateProfilePayload,
  CreateOrganizationPayload,
  PartnerActionPayload,
  OrganizationSearchResponse,
  ProposedPartnersResponse,
  PlansResponse,
} from '../model/types';

export class AccountSetupService {
  async updateProfile(payload: UpdateProfilePayload): Promise<void> {
    await apiService.patch(API_ENDPOINTS.USER.UPDATE_PROFILE, payload);
  }

  async createOrganization(payload: CreateOrganizationPayload): Promise<void> {
    await apiService.post(API_ENDPOINTS.PARTNERS.PARTNER_ORG_INFO_UPDATE, payload);
  }

  async askToJoinOrganization(orgId: string): Promise<void> {
    const payload: PartnerActionPayload = {
      action_type: 'request',
      action_mode: 'add',
      target_id: orgId,
    };
    await apiService.post(API_ENDPOINTS.PARTNERS.ACTION, payload);
  }

  async searchOrganizations(query: string): Promise<OrganizationSearchResponse> {
    return apiService.get<OrganizationSearchResponse>(API_ENDPOINTS.PARTNERS.ORG_SEARCH(query));
  }

  async getProposedPartners(): Promise<ProposedPartnersResponse> {
    return apiService.get<ProposedPartnersResponse>(API_ENDPOINTS.PARTNERS.PARTNER_PROPOSE);
  }

  async getPlans(): Promise<PlansResponse> {
    return apiService.get<PlansResponse>(API_ENDPOINTS.SUBSCRIPTIONS.GET_PLANS);
  }
}

export const accountSetupService = new AccountSetupService();
